export enum Backgrounds {
  'pink-yellow' = 'linear-gradient(to bottom right, #eb457c, #ffc857)',
  'blue-purple-pink-orange' = 'linear-gradient(to bottom right, #4e60d3, #913baf, #d52d88, #f26d4f)',
  'blue-white' = 'linear-gradient(to bottom right, #4014b9, #c2e0d4)',
  's-orange' = 'rgb(235 99 69 / 1)',
  's-green' = 'rgb(55 186 143 / 1)',
  's-blue' = 'rgb(54 97 185 / 1)',
  's-pink' = 'rgb(235 69 124 / 1)',
  's-black' = 'rgb(51 51 51 / 1)',
}
